import * as React from 'react';
import { ActorApiNumberDisplay } from '../../../../../../components/display/number/component';
import { useBondSameIssuerSMarketQtMin, useBondsSameIssuerIsRedacted } from '../../hooks';

export const BondSameIssuersSMarketQtMin = (props: {
  withRedactedIcon?: boolean,
}) => {
  const {
    withRedactedIcon,
  } = props;
  const {
    data,
    isLoading,
    error,
  } = useBondSameIssuerSMarketQtMin();
  const {
    data: redacted,
    isLoading: redactedIsLoading,
  } = useBondsSameIssuerIsRedacted('S_MARKET.QT_MIN');
  return (
    <ActorApiNumberDisplay
      data={data}
      isLoading={isLoading || redactedIsLoading}
      error={error}
      format={{
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }}
      loadingValue={10000}
      isBlocked={redacted}
      withRedactedIcon={withRedactedIcon}
    />
  );
};
